
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WLDomainCard extends Vue {
  @Prop({ type: Boolean, default: false })
  public bordered;

  @Prop({ type: String })
  public buttonText;

  @Prop({ type: String })
  public domainSlug;

  @Prop({ type: String })
  public title;

  @Prop({ type: Object })
  public to;
}
